import * as React from 'react';
import {CenterVerticalWrapper} from '../styled-components/CenterWrapper';
import {WP_CONTENT_PREFIX, SCREENS} from '../constants';
import styled from 'styled-components';
import I18n from "../utils/i18n";

const Avatar = styled.img`
    height: 7vh;
`;

const HeartsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 1vw;
`;

const HeartsImagesWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

const Heart = styled.div`
    background: url('${props => props.src}') no-repeat;
    background-size: 4vh;
    height: 4vh;
    width: 4vh;
    margin: 0 0.25vw;
    position: relative;
`;

const HeartAnimation = styled.div`
    background: url('${props => props.src}') no-repeat;
    background-size: 4vh;
    height: 4vh;
    width: 4vh;
    position: absolute;
    top: 0;
    left: -0.5vh;
    margin: 0 0.25vw;
    opacity: 0;
`;

const HeartHalfFullAnimation = styled.div`
    background: url('${props => props.src}') no-repeat;
    background-size: 4vh;
    height: 4vh;
    width: 4vh;
    position: absolute;
    top: 0;
    left: -0.5vh;
    margin: 0 0.25vw;
    opacity: 0;
`;

const HeartsText = styled.div`
    font-family: 'Pixel Coleco';
    font-size: 1.5vh;
    color: #ffffff;
    margin-bottom: 1vh;
`;

export const Sound = styled.img`
    height: 7vh;
`;

export const SoundText = styled.div`
    font-size: 1.7vh;
    color: #fed230;
    font-family: 'Pixel Coleco';
`;

const StatusBarDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 10vh;
  width: 96vw;
  margin: 0 2vw;
`;

export class StatusBar extends React.Component {

    constructor() {
        super();
        this.renderHearts = this.renderHearts.bind(this);
    }

    renderHearts() {
        const {screen} = this.props;
        let hearts = [];
        let i;

        for(i = 0; i < screen - 1; i++){
            if(i === screen - 2) {
                hearts.push(
                    <Heart src={`${WP_CONTENT_PREFIX}/images/heart-empty.svg`}>
                        <HeartAnimation id={`full-${screen}`} className={screen !== SCREENS.second && screen !== SCREENS.fifth ? "animation-heart-full" : ""} src={`${WP_CONTENT_PREFIX}/images/heart-full.svg`}/>
                    </Heart>);
            } else {
                hearts.push(<Heart src={`${WP_CONTENT_PREFIX}/images/heart-full.svg`} />);
            }
        }
        if(screen !== SCREENS.sixth) {
            hearts.push(<Heart src={`${WP_CONTENT_PREFIX}/images/heart-empty.svg`}>
                <HeartHalfFullAnimation id={`half-full-${screen}`} className={screen !== SCREENS.second && screen !== SCREENS.fifth ? "animation-heart-half-empty" : ""} src={`${WP_CONTENT_PREFIX}/images/heart-half.svg`} />
            </Heart>);
            i++;
            for(;i < SCREENS.sixth - 1; i++){
                hearts.push(<Heart src={`${WP_CONTENT_PREFIX}/images/heart-empty.svg`} />)
            }
        }

        return React.createElement(HeartsImagesWrapper, {}, ...hearts);
    }

    render() {
        const {toggleMusicPlaying, musicPlaying} = this.props;
        return (
            <StatusBarDiv>
                <CenterVerticalWrapper>
                    <Avatar src={`${WP_CONTENT_PREFIX}/images/avatar.png`} />
                    <HeartsWrapper>
                        <HeartsText>{I18n.translate('hearts')}</HeartsText>
                        <div>{this.renderHearts()}</div>
                    </HeartsWrapper>
                </CenterVerticalWrapper>
                <CenterVerticalWrapper>
                    <SoundText>{musicPlaying ? I18n.translate('soundOff') : I18n.translate('soundOn')}</SoundText>
                    <Sound src={`${WP_CONTENT_PREFIX}/images/sound_${musicPlaying ? 'on' : 'off'}.png`} onClick={toggleMusicPlaying}/>
                </CenterVerticalWrapper>
            </StatusBarDiv>
        );
    }
}
